import { useSignatureStore } from "@/stores/v2/signatureStore";
import { parseDomain } from "@/utils/urlUtils";

export const convertWebsiteToSignature = (website: string): string | undefined => {
	const domain = parseDomain(website);
	if (!domain) {
		return undefined;
	}

	return useSignatureStore.getState().findSignatureByUrl(domain)?.id;
};
